// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Composite API
 * HTTP API for managing Neo4j composite database instances.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface HandlersAliasResponse
 */
export interface HandlersAliasResponse {
  /**
   *
   * @type {string}
   * @memberof HandlersAliasResponse
   */
  aliasName?: string;
  /**
   *
   * @type {string}
   * @memberof HandlersAliasResponse
   */
  auraDbId?: string;
  /**
   *
   * @type {string}
   * @memberof HandlersAliasResponse
   */
  compositeDatabase?: string;
  /**
   *
   * @type {string}
   * @memberof HandlersAliasResponse
   */
  createdAt?: string;
  /**
   *
   * @type {string}
   * @memberof HandlersAliasResponse
   */
  deletedAt?: string;
  /**
   *
   * @type {string}
   * @memberof HandlersAliasResponse
   */
  id?: string;
  /**
   *
   * @type {string}
   * @memberof HandlersAliasResponse
   */
  location?: string;
  /**
   *
   * @type {string}
   * @memberof HandlersAliasResponse
   */
  remoteUrl?: string;
  /**
   *
   * @type {string}
   * @memberof HandlersAliasResponse
   */
  targetDatabase?: string;
}

/**
 * Check if a given object implements the HandlersAliasResponse interface.
 */
export function instanceOfHandlersAliasResponse(
  value: object,
): value is HandlersAliasResponse {
  return true;
}

export function HandlersAliasResponseFromJSON(
  json: any,
): HandlersAliasResponse {
  return HandlersAliasResponseFromJSONTyped(json, false);
}

export function HandlersAliasResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): HandlersAliasResponse {
  if (json == null) {
    return json;
  }
  return {
    aliasName: json['aliasName'] == null ? undefined : json['aliasName'],
    auraDbId: json['auraDbId'] == null ? undefined : json['auraDbId'],
    compositeDatabase:
      json['compositeDatabase'] == null ? undefined : json['compositeDatabase'],
    createdAt: json['createdAt'] == null ? undefined : json['createdAt'],
    deletedAt: json['deletedAt'] == null ? undefined : json['deletedAt'],
    id: json['id'] == null ? undefined : json['id'],
    location: json['location'] == null ? undefined : json['location'],
    remoteUrl: json['remoteUrl'] == null ? undefined : json['remoteUrl'],
    targetDatabase:
      json['targetDatabase'] == null ? undefined : json['targetDatabase'],
  };
}

export function HandlersAliasResponseToJSON(json: any): HandlersAliasResponse {
  return HandlersAliasResponseToJSONTyped(json, false);
}

export function HandlersAliasResponseToJSONTyped(
  value?: HandlersAliasResponse | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    aliasName: value['aliasName'],
    auraDbId: value['auraDbId'],
    compositeDatabase: value['compositeDatabase'],
    createdAt: value['createdAt'],
    deletedAt: value['deletedAt'],
    id: value['id'],
    location: value['location'],
    remoteUrl: value['remoteUrl'],
    targetDatabase: value['targetDatabase'],
  };
}
